<template>
  <div style="height: 100%">
    <div class="img">
      <!-- <img src="../assets/images/login_background.svg" alt="" /> -->
    </div>
    <div class="opacity_wrapper"></div>
    <div class="form_container">
      <div class="section1">
        <div class="section_header_wrap">
          <div @click="goBack" class="back_btn_box">
            <img src="../assets/images/procedure//icon_arrow-left_black.svg" />
            <div>뒤로</div>
          </div>
          <img class="img_logo" src="../assets/images/joyworks_logo3.png" style="cursor: pointer" @click="goHome" alt="" />
        </div>
        <div class="text_box">
          <div class="user_text">
            <span class="text_highlight">{{ userInfo?.EMP_NO }}</span> 님
          </div>
          <div class="detail_title_text">A/S 현재 진행 상태</div>
        </div>
      </div>
      <div class="section2">
        <div class="step_wrap">
          <el-steps :active="detailData.STATUS" finish-status="success" align-center>
            <el-step title="접수등록" />
            <el-step title="접수확인" />
            <el-step title="수선진행중" />
            <el-step title="택배배송" />
          </el-steps>
        </div>
      </div>
      <div v-if="detailData.COURIER_TYPE == '02'" class="section3">
        <div class="info_wrap">
          <div class="info_text company">매장명</div>
          <div class="info_text company_name">{{ detailData.STR_NAME }}</div>
        </div>
      </div>
      <div v-if="detailData.COURIER_TYPE == '01'" class="section3">
        <div class="info_wrap">
          <div class="info_text company">택배회사</div>
          <div class="info_text company_name">{{ detailData.COURIER_NAME }}</div>
        </div>
        <div class="info_wrap">
          <div class="info_text company">송장번호</div>
          <div class="info_text company_name">{{ detailData.CHUL_NO }}</div>
        </div>
        <div>
          <div @click="goPage" class="chul_btn">택배사 조회</div>
        </div>
      </div>
      <div class="section3">
        <div @click="registPage" class="button_box">
          <div class="button_text">{{ textValue }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import router from "@/router";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import repairAPI from "@/api/repairAPI";
import authAPI from "@/api/authAPI";
const store = useStore();
const route = useRoute();
const userInfo = ref();
const textValue = ref("");
const detailData: any = ref({
  COLOR_NAME: null,
  CUS_HP_NO: "",
  CUS_NAME: "",
  DATES: "",
  EMP_NAME: null,
  E_STATUS: "",
  IMG_LIST: [],
  ITM_NAME: "",
  SEQ_NO: "",
  SIZE_NAME: null,
  STATUS: "",
  STR_NAME: "",
  CHUL_NO: "",
  COURIER_CODE: "",
  COURIER_NAME: "",
});
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};
onMounted(() => {
  checkSession();
  userInfo.value = store.getters.getUserInfo;
  repairAPI.GetRepairDetail({ SEQ_NO: route.params.SEQ_NO, CUS_HP_NO: userInfo.value.EMP_NO }).then((res: any) => {
    console.log("123", res.data.data);
    detailData.value = res.data.data;
    if (detailData.value.COURIER_CODE == "01") {
      detailData.value.COURIER_NAME = "대한통운";
    } else if (detailData.value.COURIER_CODE == "02") {
      detailData.value.COURIER_NAME = "로젠";
    } else {
      detailData.value.COURIER_NAME = "";
    }
    textValue.value = detailData.value.CS_STATUS == null ? "접수내용 (수정)" : "접수내용 (확인)";
    console.log(detailData.value.STATUS);
    if (detailData.value.STATUS == "01" && detailData.value.CS_STATUS == null) {
      detailData.value.STATUS = 1;
    } else if (detailData.value.STATUS == "01" && detailData.value.CS_STATUS != null) {
      detailData.value.STATUS = 2;
    } else if (detailData.value.STATUS == "02" || detailData.value.STATUS == "03" || detailData.value.STATUS == "04") {
      detailData.value.STATUS = 3;
    } else {
      detailData.value.STATUS = 4;
    }

    // detailData.value.STATUS = Number(detailData.value.STATUS);
  });
});
const registPage = () => {
  router.push({ name: "clientUpdate", params: { SEQ_NO: detailData.value.SEQ_NO } });
};
const goHome = () => {
  router.push({ name: "clientHome" });
};
const goBack = () => {
  router.go(-1);
};
const goPage = () => {
  const chul_no: any = detailData.value.CHUL_NO;
  const url: string = `https://trace.cjlogistics.com/web/detail.jsp?slipno=${chul_no}`;
  window.open(url, "_blank");
};
</script>
<style scoped>
.section_header_wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 26px;
}
.section_header_wrap > img {
  height: 26px;
}
.section_header_wrap > div:nth-child(2) {
  height: 26px;
}
.back_btn_box {
  display: flex;
  align-items: center;
  float: left;
  cursor: pointer;
}
.section_header_wrap > img:last-child {
  margin-left: calc(50% - 110px);
  margin-right: auto;
}
.opacity_wrapper {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  position: fixed;
  top: 0px;
  left: 0px;
}
.form_container {
  background: white;
  position: fixed;
  top: calc(0%);
  right: calc(10%);
  width: 382px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.section1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 160px;
  padding: 30px 28px 28px 28px;
}

.text_box {
  display: flex;
  gap: 4px;
  flex-direction: column;
}
.user_text {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  line-height: 23px;
  letter-spacing: -0.5px;
}
.text_highlight {
  color: #006da1;
  font-family: "Noto Sans CJK KR-Bold";
}
.detail_title_text {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 20px;
  line-height: 23px;
  letter-spacing: -0.5px;
}
.section2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0px 10px 36px 10px;
}
.section3 {
  padding: 30px 40px 30px 40px;
  height: 100%;
  gap: 30px;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
}
.button_box {
  margin-top: auto;
}
.button_text {
  width: 100%;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #ffffff;
  line-height: 22px;
  text-align: center;
  background-color: #006da1;
  border-radius: 6px;
  cursor: pointer;
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chul_btn {
  width: 100%;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #006da1;
  line-height: 22px;
  text-align: center;
  border: 1px solid #006da1;
  border-radius: 8px;
  cursor: pointer;
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info_wrap {
  display: flex;
  gap: 20px;
}
.info_text.company {
  color: #000000;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 13px;
  line-height: 18px;
}
.info_text.company_name {
  font-size: 13px;
  color: #999999;
  line-height: 18px;
  font-family: "Noto Sans CJK KR-Medium";
  cursor: pointer;
}
</style>
